import axios from 'axios';
import {useQuery, UseQueryResult} from 'react-query';
import { environment } from '../config/environment';

export const fetchBlock = (block_height_or_hash: number | string) =>{
  let query = [];
  if (typeof block_height_or_hash === 'number'){
    query.push('height=' + block_height_or_hash);
  }
  if (typeof block_height_or_hash === 'string'){
    query.push('hash=' + block_height_or_hash);
  }
  return axios
      .get(`${environment.apiBase}/block/detail?${query.join('&')}`)
      .then((res) => res.data);
}


export const useBlock = (block_height_or_hash: number | string):UseQueryResult<any> => {
  let k = block_height_or_hash;
  if (
    typeof block_height_or_hash === 'string' &&
    !block_height_or_hash.startsWith('0x')
  ) {
    k = Number(k);
  }
  return useQuery(['block', k], () => fetchBlock(k), {
    retry: false,
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export default useBlock;
